<script>
import { mapGetters, mapActions } from "vuex";
import { required, requiredIf } from "vuelidate/lib/validators";
import DropzonePopup from "../../../components/widgets/dropzone-popup";
import appConfig from "@/app.config";
// import { param } from "express/lib/request";
/**
 * Add-product component
 */
export default {
  page: {
    title: "User-Charger",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      user_id: "",
      qr_code_image: "",
      qr_code_image_path: "",
      qr_code_image_delete_url: process.env.VUE_APP_APIURL + "delete-qr-code-image",
      qr_code: {
        image: "",
      },
      fields: [
        {
          key: "id",
          sortable: true,
          label: "#",
        },
        {
          key: "name",
          sortable: true,
          label: "Name",
        },
        {
          key: "address",
          sortable: true,
          label: "Address",
        },
        {
          key: "city",
          sortable: true,
          label: "City",
        },
        {
          key: "is_private",
          sortable: true,
          label: "Type",
        },
        {
          key: "price",
          sortable: true,
          label: "Price (/kWh)",
        },
      ],
    };
  },
  props: ["userId"],
  components: { DropzonePopup },
  validations: {
    newlocation: {
      address: { required },
      city: { required },
      is_private: { required },
      zip_code: { required },
      start_time: {
        required: requiredIf(function () {
          return this.newlocation.is_private == 0;
        }),
      },
      end_time: {
        required: requiredIf(function () {
          return this.newlocation.is_private == 0;
        }),
      },
      image: "",
      price: { required },
    },
  },
  computed: {
    ...mapGetters("charger", [
      "typesubmit",
      "allCharger",
      "newlocation",
      "charger",
      "loading",
    ]),
  },
  mounted() {
    this.getCharger({
      userId: this.convertDecodeId(this.$route.params.id),
    });
  },
  methods: {
    ...mapActions("charger", [
      "updateChargerLocation",
      "getChargerLocation",
      "resetChargerLocation",
      "deleteChargerLocation",
      "addChargerLocation",
      "getAllChargerData",
      "getCharger",
    ]),
    onUserImagedeleted() {
      this.qr_code.image = "";
    },
    getAddressData: function (addressData) {
      //  placeResultData, id
      this.newlocation.latitude = addressData.latitude;
      this.newlocation.longitude = addressData.longitude;
      this.newlocation.city = addressData.locality;
      this.newlocation.zip_code = addressData.postal_code;
      this.newlocation.address = addressData.route;
    },
    typeForm() {
      this.$v.$touch();
      if (this.$v.newlocation.$invalid) {
        return;
      } else {
        if (!this.newlocation.id) {
          const fd = new FormData();
          fd.append("address", this.newlocation.address);
          fd.append("city", this.newlocation.city);
          fd.append("latitude", this.newlocation.latitude);
          fd.append("longitude", this.newlocation.longitude);
          fd.append("longitude", this.newlocation.longitude);
          fd.append("is_private", this.newlocation.is_private);
          fd.append("zip_code", this.newlocation.zip_code);
          fd.append("user_id", this.convertDecodeId(this.$route.params.id));
          fd.append("start_time", this.newlocation.start_time);
          fd.append("end_time", this.newlocation.end_time);
          fd.append("price", this.newlocation.price);
          if (this.qr_code.image) {
            fd.append("image", this.qr_code.image);
          }
          this.addChargerLocation(fd);

          this.$bvModal.hide("bv-modal-location");
        } else {
          const fd = new FormData();
          fd.append("address", this.newlocation.address);
          fd.append("city", this.newlocation.city);
          fd.append("latitude", this.newlocation.latitude);
          fd.append("longitude", this.newlocation.longitude);
          fd.append("longitude", this.newlocation.longitude);
          fd.append("is_private", this.newlocation.is_private);
          fd.append("zip_code", this.newlocation.zip_code);
          fd.append("user_id", this.convertDecodeId(this.$route.params.id));
          fd.append("start_time", this.newlocation.start_time);
          fd.append("end_time", this.newlocation.end_time);
          fd.append("price", this.newlocation.price);
          fd.append("id", this.newlocation.id);
          if (this.qr_code.image) {
            fd.append("image", this.qr_code.image);
          }
          this.updateChargerLocation(fd);
          this.$bvModal.hide("bv-modal-location");
        }
        setTimeout(() => {
          this.getCharger({
            userId: this.convertDecodeId(this.$route.params.id),
          });
        }, 1000);
      }
    },
    resetForm() {
      this.$v.$reset();
    },
    editLocation(locationId) {
      this.getChargerLocation({
        locationId: locationId,
      }).then(() => {
        this.$bvModal.show("bv-modal-location");
      });
    },
    // sortingChanged(ctx) {
    //   this.sortBy = ctx.sortBy;
    //   this.sortDesc = ctx.sortDesc;
    //   this.getCharger({
    //     userId: this.convertDecodeId(this.$route.params.id),
    //   });
    // },
    newLocation() {
      this.resetChargerLocation().then(() => {
        this.$bvModal.show("bv-modal-location");
      });
    },
    deleteLocation(id) {
      this.deleteChargerLocation({
        id: id,
      });
      setTimeout(() => {
        this.getCharger({
          userId: this.convertDecodeId(this.$route.params.id),
        });
      }, 1000);
    },
    convertDecodeId(id) {
      return (this.user_id = atob(id));
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-12">
      <form action="#" @submit.prevent="typeForm">
        <!-- profile Info Start -->
        <div class="card details-profile-main">
          <div class="card-body">
            <div class="col-md-12">
              <div
                class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
              >
                <h4 class="card-title page-title-left">Chargers</h4>
                <!-- <b-button
                  class="page-title-right btn btn-success btn-rounded mr-2 add-btn"
                  @click="
                    newLocation();
                    $bvModal.show('bv-modal-location');
                  "
                  ><i class="mdi mdi-plus mr-1"></i>
                  Add
                </b-button> -->
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <b-table
                  striped
                  hover
                  :items="allCharger"
                  :fields="fields"
                  :busy="loading"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{ $t(" Loading") }}</strong>
                    </div>
                  </template>
                  <template v-slot:cell(name)="items">
                    {{ items.item.name ? items.item.name : "" }}
                  </template>
                  <template v-slot:cell(address)="items">
                    {{ items.item.address ? items.item.address : "-" }}
                  </template>
                  <template v-slot:cell(city)="items">
                    {{ items.item.city ? items.item.city : "-" }}
                  </template>
                  <template v-slot:cell(is_private)="items">
                    {{ items.item.is_private == 1 ? "Private" : "Public" }}
                  </template>
                  <template v-slot:cell(price)="items">
                    {{ items.item.is_private == 0 ? items.item.price : "-" }}
                    {{ items.item.is_private == "0" ? "(/kWh)" : "" }}
                  </template>
                </b-table>
                <tr v-if="allCharger <= '1'">
                  <td colspan="100%">
                    <h6 align="center">No Charger Data Found</h6>
                  </td>
                </tr>
              </div>
            </div>
          </div>
        </div>
        <!-- profile Info End -->
      </form>
    </div>

    <b-modal id="bv-modal-location" hide-footer @hidden="resetForm">
      <template #modal-title v-if="!newlocation.id">Add Charger</template>
      <template #modal-title v-else> Edit Charger </template>

      <form action="#" @submit.prevent="typeForm">
        <div class="row">
          <div class="col-sm-12 mb-3">
            <label>Search Address</label>
            <vue-google-autocomplete
              ref="address"
              id="map"
              classname="form-control"
              placeholder="Type address"
              v-on:placechanged="getAddressData"
            >
            </vue-google-autocomplete>
          </div>
          <div class="col-sm-6">
            <div class="form-group mb-3">
              <label>Address</label>
              <input
                id="user_name"
                type="text"
                class="form-control"
                placeholder="Enter Name"
                v-model="$v.newlocation.address.$model"
                name="name"
                :class="{ 'is-invalid': $v.newlocation.address.$error }"
                readonly
              />
              <div v-if="$v.newlocation.address.$error" class="invalid-feedback">
                <span v-if="!$v.newlocation.address.required">Please enter address</span>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group mb-3">
              <label>City</label>
              <input
                id="user_name"
                type="text"
                class="form-control"
                placeholder="Enter City"
                v-model="$v.newlocation.city.$model"
                :class="{ 'is-invalid': $v.newlocation.city.$error }"
                name="name"
                readonly
              />
              <div v-if="$v.newlocation.city.$error" class="invalid-feedback">
                <span v-if="!$v.newlocation.city.required">Please enter city name</span>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group mb-3">
              <label>Postal code</label>
              <input
                id="user_name"
                type="text"
                class="form-control"
                placeholder="Enter zipcode"
                v-model="$v.newlocation.zip_code.$model"
                name="name"
                :class="{ 'is-invalid': $v.newlocation.zip_code.$error }"
              />
              <div v-if="$v.newlocation.zip_code.$error" class="invalid-feedback">
                <span v-if="!$v.newlocation.zip_code.required"
                  >Please enter postal code</span
                >
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group mb-3">
              <label>Price (/kWh)</label>
              <input
                id="price"
                type="number"
                class="form-control"
                placeholder="Enter Price (/kWh)"
                v-model="$v.newlocation.price.$model"
                name="name"
                :class="{ 'is-invalid': $v.newlocation.price.$error }"
              />
              <div v-if="$v.newlocation.price.$error" class="invalid-feedback">
                <span v-if="!$v.newlocation.price.required">Please enter price</span>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group mb-3">
              <label>Charger Type</label>
              <b-form-select v-model="$v.newlocation.is_private.$model" class="mb-3">
                <b-form-select-option value="0"> Public </b-form-select-option>
                <b-form-select-option value="1"> Private </b-form-select-option>
              </b-form-select>
            </div>
          </div>
        </div>

        <!-- Time Slot Section Start -->
        <div class="row mt-n3" v-if="newlocation.is_private == '0'">
          <div class="col-sm-6">
            <div class="form-group mb-3">
              <b-form-group
                id="start_time"
                label="Start Time"
                label-for="start"
                label-class="required"
              >
                <b-form-input
                  class="form-control"
                  v-model="$v.newlocation.start_time.$model"
                  id="start_time"
                  type="time"
                  :class="{ 'is-invalid': $v.newlocation.start_time.$error }"
                ></b-form-input>
                <div v-if="$v.newlocation.start_time.$error" class="invalid-feedback">
                  <span v-if="!$v.newlocation.start_time.required">
                    Please select start time</span
                  >
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group mb-3">
              <b-form-group
                id="end_time"
                label="End Time"
                label-for="end"
                label-class="required"
              >
                <b-form-input
                  class="form-control"
                  v-model="$v.newlocation.end_time.$model"
                  id="end_time"
                  type="time"
                  :class="{ 'is-invalid': $v.newlocation.end_time.$error }"
                ></b-form-input>
                <div v-if="$v.newlocation.end_time.$error" class="invalid-feedback">
                  <span v-if="!$v.newlocation.end_time.required">
                    Please select end time</span
                  >
                </div>
              </b-form-group>
            </div>
          </div>
        </div>
        <!-- Time Slot Section End -->

        <!-- Image Section Start -->
        <div class="row mt-n3 card">
          <div class="card-body">
            <h4 class="card-title required">QR Code Image</h4>
            <p class="card-title-desc"></p>

            <div class="row mt-n3">
              <div class="col-sm-3">
                <dropzone-popup
                  type="file"
                  v-model="qr_code.image"
                  id="qr_code_image"
                  acceptedFiles=".jpeg,.jpg,.png"
                  :editable-images="newlocation.image"
                  :media-path="newlocation.qr_code_image_path + 'original'"
                  :delete-path="qr_code_image_delete_url"
                  :custom-params="{ id: newlocation.id }"
                  :class="{ 'is-invalid': $v.newlocation.image.$error }"
                  @image-deleted="this.onUserImagedeleted"
                />
                <div
                  v-if="$v.newlocation.image.$error"
                  class="invalid-feedback cuisine-img"
                >
                  <span v-if="!$v.newlocation.image.required">Image is required.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Image Section End -->

        <div class="text-end mt-3">
          <button
            type="button"
            @click="
              resetChargerLocation();
              $bvModal.hide('bv-modal-location');
            "
            class="btn btn-light"
          >
            Close
          </button>
          <button type="submit" class="btn ms-1 btn-success">Submit</button>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<style>
.pac-container {
  z-index: 9999 !important;
}
</style>
